import {Subscription} from 'rxjs';

import IPlayer                   from '../../../Player/Interfaces/IPlayer';
import createPlayRejectionStream from '../../../Solutions/Shared/Streams/createPlayRejectionStream';

import createBufferingStream              from './Streams/createBufferingStream';
import createEndedStream                  from './Streams/createEndedStream';
import createFastForwardTapStream         from './Streams/createFastForwardTapStream';
import createKeypressSpaceStream          from './Streams/createKeypressSpaceStream';
import createPauseStream                  from './Streams/createPauseStream';
import createPlaybackQualityChangeStream  from './Streams/createPlaybackQualityChangeStream';
import createPlaybackQualityStream        from './Streams/createPlaybackQualityStream';
import createPlayPauseTapStream           from './Streams/createPlayPauseTapStream';
import createPlayStream                   from './Streams/createPlayStream';
import createRewindTapStream              from './Streams/createRewindTapStream';
import createSeekToLiveEdgeTapStream      from './Streams/createSeekToLiveEdgeTapStream';
import createTimecodeTapStream            from './Streams/createTimecodeTapStream';
import createTimelineTapStream            from './Streams/createTimelineTapStream';
import createTimeUpdateStream             from './Streams/createTimeUpdateStream';
import subscribeToBuffering               from './Subscribers/subscribeToBuffering';
import subscribeToConsumerError           from './Subscribers/subscribeToConsumerError';
import subscribeToConsumerSeek            from './Subscribers/subscribeToConsumerSeek';
import subscribeToConsumerTogglePlayPause from './Subscribers/subscribeToConsumerTogglePlayPause';
import subscribeToEnded                   from './Subscribers/subscribeToEnded';
import subscribeToFastForwardTap          from './Subscribers/subscribeToFastForwardTap';
import subscribeToKeypressSpace           from './Subscribers/subscribeToKeypressSpace';
import subscribeToMediaStoreUpdate        from './Subscribers/subscribeToMediaStoreUpdate';
import subscribeToPause                   from './Subscribers/subscribeToPause';
import subscribeToPlay                    from './Subscribers/subscribeToPlay';
import subscribeToPlaybackQualityChange   from './Subscribers/subscribeToPlaybackQualityChange';
import subscribeToPlayPauseTap            from './Subscribers/subscribeToPlayPauseTap';
import subscribeToPlayRejection           from './Subscribers/subscribeToPlayRejection';
import subscribeToRewindTap               from './Subscribers/subscribeToRewindTap';
import subscribeToSeekToLiveEdgeTap       from './Subscribers/subscribeToSeekToLiveEdgeTap';
import subscribeToTimecodeTap             from './Subscribers/subscribeToTimecodeTap';
import subscribeToTimelineTap             from './Subscribers/subscribeToTimelineTap';
import subscribeToTimeUpdate              from './Subscribers/subscribeToTimeUpdate';

const connectPlaybackSubscriptions = (player: IPlayer): Subscription[] => {
    const {solution, consumerInput} = player;
    const {mediaEvents$} = solution;
    const {uiEvents$} = player.ui;
    const {playback, media, frame, volume} = player.state.stores;
    const timeUpdate$ = createTimeUpdateStream(mediaEvents$);
    const playbackQuality$ = createPlaybackQualityStream(solution);

    return [
        subscribeToBuffering(createBufferingStream(mediaEvents$, playback.update$), playback),
        subscribeToConsumerError(consumerInput.error$, playback),
        subscribeToConsumerSeek(consumerInput.seek$, playback),
        subscribeToConsumerTogglePlayPause(consumerInput.togglePlayPause$, playback),
        subscribeToEnded(createEndedStream(mediaEvents$, playback.update$), playback),
        subscribeToFastForwardTap(createFastForwardTapStream(uiEvents$), playback),
        subscribeToKeypressSpace(createKeypressSpaceStream(window, frame.update$), playback),
        subscribeToMediaStoreUpdate(media.update$, playback),
        subscribeToPause(createPauseStream(mediaEvents$, playback.update$), playback),
        subscribeToPlay(createPlayStream(mediaEvents$, playback.update$), playback),
        subscribeToPlayPauseTap(createPlayPauseTapStream(uiEvents$), playback),
        subscribeToRewindTap(createRewindTapStream(uiEvents$), playback),
        subscribeToSeekToLiveEdgeTap(createSeekToLiveEdgeTapStream(uiEvents$), playback),
        subscribeToTimecodeTap(createTimecodeTapStream(uiEvents$), playback),
        subscribeToTimelineTap(createTimelineTapStream(uiEvents$, playback.update$), playback),
        subscribeToTimeUpdate(timeUpdate$, playback),
        subscribeToPlaybackQualityChange(createPlaybackQualityChangeStream(playbackQuality$), playback),
        subscribeToPlayRejection(createPlayRejectionStream(solution.mediaEvents$), playback, volume)
    ];
};

export default connectPlaybackSubscriptions;